<template>
  <div class="ai-chat-message">
    <!-- Text message -->
    <AIChatMessageText
      v-if="message.kind === MESSAGE_TYPE.text"
      :message="message"
      @done-typing="$emit('done-typing')"
    />
    <!-- Card message (image/button) -->
    <template v-else-if="message.kind === MESSAGE_TYPE.cards">
      <component
        :is="getCardComponent(message)"
        :message="message"
        @upload-picture="$emit('upload-picture')"
        @try-on="e => $emit('try-on', e)"
        @select-size="e => $emit('select-size', e)"
        @on-image-click="e => $emit('on-image-click', e)"
        @learn-more="e => $emit('learn-more', e)"
      />
    </template>
    <!-- Action message -->
    <template v-else-if="message.kind === MESSAGE_TYPE.action">
      <component
        :is="getActionComponent(message)"
        :message="message"
        @begin-scan="$emit('begin-scan')"
        @upload-image="e => $emit('upload-image', e)"
      />
    </template>
  </div>
</template>

<script>
import { MESSAGE_TYPE, CARD_TYPE, ACTION_TYPE } from '@/views/BodyAI/Chat/messages/constants/index';
import AIChatMessageText from './AIChatMessageText.vue';
import AIChatMessageVto from './AIChatMessageVto.vue';
import AIChatMessageBodyScan from './AIChatMessageBodyScan.vue';
import AIChatMessageUploadImage from './AIChatMessageUploadImage.vue';
import AIChatMessageCards from './AIChatMessageCards.vue';
import AIChatMessageSizeSelection from './AIChatMessageSizeSelection.vue';
import AIChatMessageAnalysis from './AIChatMessageAnalysis.vue';

export default {
  components: {
    AIChatMessageText,
    AIChatMessageVto,
    AIChatMessageBodyScan,
    AIChatMessageUploadImage,
    AIChatMessageCards,
    AIChatMessageSizeSelection,
    AIChatMessageAnalysis,
  },
  props: {
    message: {
      type: Object,
    },
  },
  data() {
    return {
      MESSAGE_TYPE,
    };
  },
  methods: {
    getCardComponent({ content }) {
      const { kind, action } = content[0];
      const isMessageCards = content.every(
        item =>
          kind === CARD_TYPE.image &&
          (item.action === ACTION_TYPE.na || item.action === ACTION_TYPE.vto)
      );

      if (isMessageCards) {
        return 'AIChatMessageCards';
      }

      if (kind === CARD_TYPE.image && !action) {
        return 'AIChatMessageVto';
      }

      if (kind === CARD_TYPE.button && action === ACTION_TYPE.vto) {
        return 'AIChatMessageSizeSelection';
      }

      if (kind === CARD_TYPE.image && action === ACTION_TYPE.explainBodyShape) {
        return 'AIChatMessageAnalysis';
      }

      return '';
    },
    getActionComponent({ content: { action } }) {
      if (action === ACTION_TYPE.requestVtoSourceImage) {
        return 'AIChatMessageUploadImage';
      }

      if (action === ACTION_TYPE.requestBodyScan) {
        return 'AIChatMessageBodyScan';
      }

      return '';
    },
  },
};
</script>

<style lang="scss" scoped>
.ai-chat-message {
}
</style>
